import { RouteObject } from "react-router-dom";
import { BusinesFunctionDetailPage } from "src/components/change-log/BusinessFunctionDetailsPage";
import { BusinessFunctionsPage } from "src/components/change-log/BusinessFunctionsPage";
import { ChangeTypesPage } from "src/components/change-log/ChangeTypesPage";
import { ChangeLogPage } from "src/routes/change-log/ChangeLogPage";
import { NotFound } from "src/routes/NotFound";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import {
  businessFunctionDetailsRoute,
  businessFunctionsRoute,
  changeLogDetailsRoute,
  changeLogRoute,
  changeTypesRoute,
} from "src/routing/domains/changeLogPaths";

/**
 * `/change-log/*` route tree.
 *
 * Role: data router domain route.
 *
 * Legacy stack without `ScrollableParentLayout` (pages previously opted out of PageLayout's
 * scroll frame via `hasOwnLayout`): `AppShell` → `GlobalNavLayout` → page.
 * When pages move to `PageHeaderLayout` / `GridTableLayout`, switch to
 * `AppShell` → `BeamNavbarLayout` → page (see `domains/projects.ts`).
 *
 * Path constants live in `changeLogPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 * Legacy `Routes.tsx` must not register these paths.
 */
const changeLogDomainRoute: RouteObject = {
  path: changeLogRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        // Static paths before `:changeRequestId` for clarity (RR6 already ranks static above params).
        { path: changeTypesRoute.path, Component: ChangeTypesPage },
        { path: businessFunctionsRoute.path, Component: BusinessFunctionsPage },
        { path: businessFunctionDetailsRoute.path, Component: BusinesFunctionDetailPage },
        { index: true, Component: ChangeLogPage },
        { path: `${changeLogDetailsRoute.path}/*`, Component: ChangeLogPage },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};

/**
 * Migrated `/change-log/*` route trees registered in `Router.tsx`.
 */
export const changeLogRoutes = [changeLogDomainRoute];
